export enum AdminApiPath {
    COMMISSION_ADMIN_PATH = 'irent/admin/commission',
}
